module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_8.76fa0465.jpg";